// extracted by mini-css-extract-plugin
module.exports = {"DataStoreSettingsNameChange":"DataStoreSettingsNameChange_uzDrQ"};